<template>
    <div class="container">
        <!-- <city-list @selectedCity="selectedCid"></city-list> -->
        <div class="text">
            <div class="textcontent" v-html="htmlData"></div>
        </div>


    </div>
</template>

<script>
// import CityList from "@/components/cityreserch/CityList.vue";
import { getLocation, fileDownload } from "../../api/Article.js";
export default {
    // components: { CityList },
   
    computed: {
        block: {
            get() {
                return this.$store.state.block;
            },
            set(v) {
                this.$store.commit("changeBlock", v);
            },
        },
    },
    data() {
        return {
            currentCate: null,
            htmlData: ""
        };
    },
    watch: {
        block(nv, ov) {
            this.getData();
        },
    },

    mounted() {
        this.currentCate = this.$router.currentRoute.meta.articleCate;
        this.getData();
    },

    methods: {
        selectedCid() { },

        //获取数据
        getData() {
            const params = {
                city_plate_id: this.block,
                cate: this.currentCate,
            };
            getLocation(params).then((res) => {

                if (res.code === 1001) {
                    this.htmlData = '暂无数据'
                } else {
                    this.htmlData = res.data.content;
                }

            });
        },

        //下载
        download(index, rowData) {
            const params = { id: rowData.id }
            fileDownload(params).then(res => {
                window.location.href = res.data.fileUrl

            })
        }

    },
};
</script>

<style lang="scss" scoped>
.container {
    width: 98%;
    margin: 0 auto;

    .table {
        width: 96%;
        margin: 0 auto;
    }
.text {
    color: #333;
    width: 98%;
    background: #f0f3f8;
    height: auto;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    margin-top:10px;
  }

  .textcontent {

    text-align: left;
    padding: 10px;
    box-sizing: border-box;
   
  }



}
</style>